import MyTeamCreatedLeadList from "./myTeamCreatedLeadList";
export default MyTeamCreatedLeadList;